import React from 'react';
import { cn } from '@/utils/cn';
import { formatCurrency } from '@/utils/format';

interface ProjectProgressKpiCardsProps {
  data: any;
}

export function ProjectProgressKpiCards({ data }: ProjectProgressKpiCardsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
      {/* Tiến độ tổng thể */}
      <KpiCard
        title="Tiến độ tổng thể"
        value={`${data.overallProgress}%`}
        status="Đang thực hiện"
        statusColor="text-emerald-500"
        subtitle="Cập nhật: 15/05/2024 09:30"
        progress={data.overallProgress}
      />

      {/* Giá trị công việc hoàn thành (EV) */}
      <KpiCard
        title="Giá trị công việc hoàn thành (EV)"
        value={formatCurrency(data.ev, 'VND')}
        subtitle="45% giá trị hợp đồng"
        barColor="bg-blue-500"
        progress={45}
      />

      {/* Giá trị kế hoạch (PV) */}
      <KpiCard
        title="Giá trị kế hoạch (PV)"
        value={formatCurrency(data.pv, 'VND')}
        subtitle="65% giá trị hợp đồng"
        barColor="bg-indigo-500"
        progress={65}
      />

      {/* Chênh lệch (EV - PV) */}
      <KpiCard
        title="Chênh lệch (EV - PV)"
        value={formatCurrency(data.variance, 'VND')}
        subtitle={`${data.variancePercent}% so với kế hoạch`}
        valueColor={data.variance < 0 ? 'text-rose-600' : 'text-emerald-600'}
        isVariance
      />
    </div>
  );
}

function KpiCard({ title, value, status, statusColor, subtitle, progress, barColor = 'bg-emerald-500', valueColor = 'text-slate-900', isVariance = false }: any) {
  return (
    <div className="bg-white p-3 space-y-2 rounded-md border border-slate-100 flex flex-col justify-between h-full">
      <div className="space-y-1.5">
        <h3 className="sm:text-sm text-xs font-normal text-slate-500 tracking-wider truncate">{title}</h3>
        <div className="flex flex-wrap items-baseline gap-1.5">
          <p className={cn("text-xl font-normal leading-none", valueColor)}>{value}</p>
          {status && <p className={cn("sm:text-sm text-xs font-normal", statusColor)}>{status}</p>}
        </div>
      </div>
      
      <div>
        {!isVariance && progress !== undefined && (
          <div className="h-1.5 rounded-full bg-slate-100 overflow-hidden mb-2">
            <div className={cn("h-full transition-all duration-700", barColor)} style={{ width: `${progress}%` }} />
          </div>
        )}
        <p className="sm:text-sm text-xs text-slate-500 font-normal">{subtitle}</p>
      </div>
    </div>
  );
}
